const getHolidayBannerData = async (bannerData, holidayDate) => {
  const processEnv = process.env || {}
  return await fetch(
    `https://cdn.contentful.com/spaces/${processEnv.VUE_APP_CTF_SPACE_ID}/environments/${processEnv.VUE_APP_CTF_ENVIRONMENT}/entries?access_token=${processEnv.VUE_APP_CTF_TOKEN}&content_type=cmaListing&locale=*`
  )
}

export default {
  getHolidayBannerData
}
